// CSS3 InfoBubble for the Google Maps API. The library declares itself on
// window, which modules/maps/index.js looks for before creating a marker
// popup, so it has to load as its own entry rather than inside a bundle.
import '../vendor/infobubble';
